import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-60d09eb9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tab-content" }
const _hoisted_2 = { class: "tab-content" }
const _hoisted_3 = { class: "two-column-row" }
const _hoisted_4 = { class: "two-column-row" }
const _hoisted_5 = { class: "two-column-row" }
const _hoisted_6 = { class: "two-column-row" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tab-content" }, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tab-content" }, null, -1))

import { computed, inject, PropType, ref, watch } from "vue";
import ModalBase from "@/components/ui/modals/modal-base.vue";
import { DxToolbarItem } from "devextreme-vue/popup";
import { DxTabPanel, DxItem } from "devextreme-vue/tab-panel";
import PropertyLookup from "@/components/ui/lookup/property-lookup.vue";
import ContactLookup from "@/components/ui/lookup/contact-lookup.vue";
import { WorkOrdersValidation } from "acquaint-api/validation/WorkOrdersValidation";
import { LookupTableSource } from "acquaint-api/constants/LookupTableSource";
import displayErrorMessage from "@/utils/ErrorHandling";
import { WorkOrders } from "acquaint-api/models/WorkOrders";
import { Properties } from "acquaint-api/models/Properties";
import { ManagementTypes } from "acquaint-api/models/ManagementTypes";
import { CodeType } from "acquaint-api/constants/CodeType";
import { AcquaintApiClient } from "@/services/AcquaintApiClient";
import AcquaintInfoBox from "@/components/ui/inputs/acquaint-info-box.vue";
import AcquaintTextbox from "@/components/ui/inputs/acquaint-textbox.vue";
import AcquaintTextArea from "@/components/ui/inputs/acquaint-text-area.vue";
import { useLookupConfigurationStore } from "@/stores/LookupConfigurationStore";
import CurrencyInfoBox from "@/components/ui/inputs/currency-info-box.vue";
import CurrencyInput from "@/components/ui/inputs/currency-input.vue";
import LookupSingleSelect from "@/components/ui/lookup/lookup-single-select.vue";
import AcquaintDateBox from "@/components/ui/inputs/acquaint-date-box.vue";
import SystemCodeSingleSelect from "@/components/ui/system-codes/system-code-single-select.vue";
import { getErrorMessage } from "bright-logic-core/src/errors";
import { ValidatedEvent } from "devextreme/ui/validator";
import { WorkOrderStatuses } from "@/enums/work-orders/WorkOrderStatuses";
import { useRouter } from "vue-router";
import { RouteNames } from "@/router/RouteNames";
import { PropertyCategory } from "acquaint-api/constants/PropertyCategory";
import { ManagamentType } from "@/enums/properties/ManagamentType";
import { standardInfoAlert } from "@/alerts/standardInfoAlert";
import { AcquaintApiNextClient } from "@/services/AcquaintApiNextClient";
import FieldValidationFreeDateBox from "@/components/ui/inputs/field-validation-free-date-box.vue";
import { WorkOrderTenantInfo } from "@/types/work-orders/WorkOrderTenantInfo";
import { displayCancelConfirmationAlert } from "@/alerts/cancelConfirmationAlert";
import WorkOrderQuotationModal from "@/components/work-orders/work-order-quotation-modal.vue";
import { MaintenanceRequests } from "acquaint-api/models/MaintenanceRequests";
import EmailWorkOrderModal from "./email-work-order-modal.vue";
import { displayQuestionAlert } from "@/alerts/questionAlert";
import ContactModal from "@/components/contacts/record/contact-modal.vue";
import { ContactType } from "@/enums/contacts/ContactType";
import { DefaultContactType } from "acquaint-api/constants/DefaultContactType";


export default /*#__PURE__*/_defineComponent({
  __name: 'work-order-modal',
  props: {
  /**
   * The boolean value used with `v-model` to control the visibility or state of a modal or component.
   * @type {boolean}
   * @required
   */
  modelValue: {
    type: Boolean,
    required: true,
  },
  /** Id of the work order
   * @type {number}
   * @default: 0
   */
  workOrderId: {
    type: Number,
    default: 0,
  },
  /** Id of the contractor
   * @type {number}
   * @default: 0
   */
  contractorId: {
    type: Number,
    default: 0,
  },
  /** Id of the property
   * @type {number}
   * @default: 0
   */
  propertyId: {
    type: Number,
    default: 0,
  },
  /** Id of the property
   * @type {number}
   * @default: 0
   */
  certificateId: {
    type: Number,
    default: 0,
  },
  /** Id of the property
   * @type {Boolean}
   * @default: false
   */
  fromMaintenanceRequest: {
    type: Boolean,
    default: false,
  },
  /**
   * The MaintenanceRequests object value
   * @type {MaintenanceRequests}
   * @default: undefined
   */
  maintenanceRequests: {
    type: Object as PropType<MaintenanceRequests>,
    default: undefined,
  },
},
  emits: [
  /**
   * Triggered when the `modelValue` changes. This is used to update the v-model variable in the parent component.
   * @property {boolean} value - Indicates whether the modal has been opened or closed.
   */
  "update:modelValue",
  /**
   * Emitted when the data has been updated.
   * Notifies the parent component to handle the update action.
   * @event workOrderUpdated
   */
  "workOrderUpdated",
  /**
   * Emitted when work order has been created.
   * Notifies the parent component to handle the create action.
   * @event workOrderCreated
   */
  "workOrderCreated",
],
  setup(__props, { emit }) {

const props = __props;





const showModal = computed({
  get: () => props.modelValue,
  set: (value: boolean) => emit("update:modelValue", value),
});

const acquaintApiClient = inject("AcquaintApiClient") as AcquaintApiClient;
const acquaintNextApiClient = inject(
  "AcquaintApiNextClient",
) as AcquaintApiNextClient;
const selectedTab = ref(0);
const defaultWorkOrder: WorkOrders = {
  id: 0,
  userID: 0,
  assignedUserID: 0,
  addedDate: "",
  dueDate: "",
  completedDate: "",
  updatedDate: "",
  workOrderTypeID: 0,
  status: 0,
  priority: 0,
  propertyID: 0,
  contractorID: 0,
  contactID: 0,
  subject: "",
  body: "",
  notes: "",
  amount: 0,
  reference: "",
  companyID: 0,
  pictures: "",
  externalID: 0,
  statusDate: "",
  certificateID: 0,
};
const router = useRouter();
const lookupConfigurationStore = useLookupConfigurationStore();
const originalWorkOrderData = ref<WorkOrders>({ ...defaultWorkOrder });
const workOrderData = ref<WorkOrders>({ ...defaultWorkOrder });
const displayCloseConfirmationPrompt = ref(false);
const lockedByAnotherUser = ref(false);
const keepingModalOpening = ref(false);
const propertyWarningIssued = ref(false);
const showWorkOrderQuoteModal = ref(false);
const propertyItem = ref<Properties>();
const managementTypeItem = ref<ManagementTypes>();
const tenantItem = ref<WorkOrderTenantInfo>();
const managementTypeDescription = ref("");
const accountBalance = ref(0);
const newWorkOrderId = ref(0);
const displayEmailModal = ref(false);
const currrentDate = ref(
  new Date(new Date(Date.now()).setHours(23, 59, 59, 59)),
);
const openNewContactModal = ref(false);

watch(
  [() => workOrderData.value, () => originalWorkOrderData.value],
  ([newWorkOrder, newOriginal]) => {
    if (JSON.stringify(newOriginal) === JSON.stringify(newWorkOrder)) {
      displayCloseConfirmationPrompt.value = false;
    } else {
      displayCloseConfirmationPrompt.value =
        JSON.stringify(newWorkOrder) !== JSON.stringify(newOriginal);
    }
  },
  { deep: true },
);

watch(
  () => showModal.value,
  async () => {
    if (keepingModalOpening.value || !showModal.value) {
      return;
    }

    tenantItem.value = undefined;
    propertyWarningIssued.value = false;
    lockedByAnotherUser.value = false;
    selectedTab.value = 0;
    displayCloseConfirmationPrompt.value = false;

    if (props.workOrderId > 0) {
      newWorkOrderId.value = props.workOrderId;
    }

    await fetchItemData();
    if (originalWorkOrderData.value) {
      originalWorkOrderData.value.completedDate =
        originalWorkOrderData.value.completedDate == "1900-01-01"
          ? ""
          : originalWorkOrderData.value.completedDate;
      workOrderData.value = JSON.parse(
        JSON.stringify(originalWorkOrderData.value),
      );
    }

    /* As new lines from the api contain \r\n due to the api being hosted in a Windows environment
     * We must replace them with \n, otherwise the character count gets out of sync */
    workOrderData.value.body = workOrderData.value.body.replace(/\r\n/g, "\n");

    if (props.workOrderId === 0) {
      if (props.certificateId > 0) {
        workOrderData.value.certificateID = props.certificateId;
        workOrderData.value.propertyID = props.propertyId;
        workOrderData.value.contractorID = props.contractorId;
        await loadPropertyData(props.propertyId);
      } else {
        if (props.propertyId > 0) {
          workOrderData.value.propertyID = props.propertyId;
          await loadPropertyData(props.propertyId);
        }
        workOrderData.value.contractorID = props.contractorId;

        if (props.maintenanceRequests) {
          workOrderData.value.externalID = props.maintenanceRequests.externalID;
          workOrderData.value.workOrderTypeID =
            props.maintenanceRequests.workOrderTypeID;
          workOrderData.value.subject = props.maintenanceRequests.subject;
          workOrderData.value.body = props.maintenanceRequests.body;

          if (props.maintenanceRequests.propertyID > 0) {
            workOrderData.value.propertyID =
              props.maintenanceRequests.propertyID;
            await loadPropertyData(props.maintenanceRequests.propertyID);
          }
        }
      }
      originalWorkOrderData.value = JSON.parse(
        JSON.stringify(workOrderData.value),
      );
    } else {
      await lockWorkOrderItem();
    }
  },
);

const fetchItemData = async () => {
  try {
    if (props.workOrderId === 0) {
      originalWorkOrderData.value = await acquaintApiClient.httpGet<WorkOrders>(
        `database/workorders/defaultmodel`,
      );
      originalWorkOrderData.value.status = WorkOrderStatuses.Outstanding;
      originalWorkOrderData.value.completedDate =
        originalWorkOrderData.value.completedDate || "1900-01-01";
      workOrderData.value = JSON.parse(
        JSON.stringify(originalWorkOrderData.value),
      );
    } else {
      workOrderData.value = await acquaintApiClient.httpGet<WorkOrders>(
        `database/workorders/${props.workOrderId}`,
      );
      await loadPropertyData(workOrderData.value.propertyID);
      originalWorkOrderData.value = JSON.parse(
        JSON.stringify(workOrderData.value),
      );
    }
  } catch (err) {
    displayErrorMessage("The selected details could not be fetched");
  }
};

const fetchProperty = async (propertyId: number) => {
  try {
    propertyItem.value = await acquaintApiClient.httpGet(
      `database/properties/${propertyId}`,
    );
  } catch (err) {
    displayErrorMessage(getErrorMessage(err));
    propertyItem.value = undefined;
  }
};

const fetchManagementType = async (managementTypeID: number) => {
  try {
    managementTypeItem.value = await acquaintApiClient.httpGet(
      `database/managementtypes/${managementTypeID}`,
    );
  } catch (err) {
    displayErrorMessage(getErrorMessage(err));
    managementTypeItem.value = undefined;
  }
};

const fetchTenantinfo = async (propertyId: number) => {
  try {
    tenantItem.value = await acquaintNextApiClient.httpGet<WorkOrderTenantInfo>(
      `/WorkOrders/${propertyId}/Tenant`,
    );
  } catch (err) {
    displayErrorMessage(getErrorMessage(err));
    tenantItem.value = undefined;
  }
};

const fetchAccountBalance = async (propertyId: number): Promise<number> => {
  try {
    const balanceItem = await acquaintApiClient.httpGet<{ balance: number }>(
      `app/workorders/${propertyId}/accountbalance`,
    );
    return balanceItem.balance;
  } catch (err) {
    displayErrorMessage(getErrorMessage(err));
    return 0;
  }
};
const lockWorkOrderItem = async () => {
  if (props.workOrderId === 0) return;
  try {
    await acquaintApiClient.httpPostVoid(
      `database/workorders/${props.workOrderId}/lock`,
      { lock: true, extraInfo: "" },
    );
  } catch (err) {
    lockedByAnotherUser.value = true;
    displayErrorMessage(
      "These details are already being edited by another user.",
    );
  }
};

const unLockWorkOrderItem = async () => {
  if (props.workOrderId === 0) return;
  try {
    await acquaintApiClient.httpPostVoid(
      `database/workorders/${props.workOrderId}/lock`,
      { lock: false, extraInfo: "" },
    );
  } catch (err) {
    displayErrorMessage("We were unable to unlock these details.");
  }
};

const cancelClick = () => {
  showModal.value = false;
};

const keepEnteredInformation = () => {
  keepingModalOpening.value = true;
};

const cancelPromptDenied = () => {
  keepingModalOpening.value = true;
};

const modalClosed = async () => {
  if (props.workOrderId > 0) {
    await unLockWorkOrderItem();
  }

  keepingModalOpening.value = false;
};

const onPropertyLookupChanged = async (propertyId: number) => {
  await loadPropertyData(propertyId);
};

const loadPropertyData = async (propertyId: number) => {
  await fetchProperty(propertyId);

  if (propertyItem.value?.category === PropertyCategory.ToLet) {
    if (propertyItem.value.managementTypeID > 0) {
      await fetchManagementType(propertyItem.value.managementTypeID);
      managementTypeDescription.value =
        await lookupConfigurationStore.getLookupConfigurationDescription(
          LookupTableSource.ManagementTypes,
          propertyItem.value?.managementTypeID ?? 0,
        );
    } else {
      managementTypeDescription.value = "";
    }
  } else {
    managementTypeDescription.value = "For Sale";
  }
  //If adding a new work order  ....
  if (workOrderData.value.id === 0 && !propertyWarningIssued.value) {
    if (propertyItem.value?.category === PropertyCategory.ToLet) {
      //Lettings - warn if not fully managed or no management type set at all
      if (
        managementTypeItem.value?.typeID !== ManagamentType.Full ||
        propertyItem.value.managementTypeID === 0
      ) {
        standardInfoAlert(
          "Warning, this property is NOT Fully Managed. Please ensure you are authorised by the Landload before you continue.",
        );
      }
    } else {
      //For Sale property
      standardInfoAlert(
        "Warning, this property is for Sale. Please ensure you are authorised by the Vendor before you continue.",
      );
    }
    propertyWarningIssued.value = true;
  }

  accountBalance.value = await fetchAccountBalance(propertyId);

  await fetchTenantinfo(propertyItem.value?.id ?? 0);
  if (tenantItem.value && tenantItem.value.contactId) {
    workOrderData.value.contactID = tenantItem.value.contactId;
  } else {
    workOrderData.value.contactID = propertyItem.value?.contactID ?? 0;
  }
};

const saveDetails = async (e: any) => {
  const validation: ValidatedEvent = e.validationGroup.validate();
  // Don't continue if user has entered invalid data
  if (!validation.isValid) {
    return;
  }

  if (!workOrderData.value.dueDate) {
    selectedTab.value = 1;
    return;
  }

  if (!(await callSaveApi())) {
    return;
  }

  if (
    workOrderData.value.status !== WorkOrderStatuses.Outstanding &&
    workOrderData.value.contractorID === 0
  ) {
    const alert = await displayCancelConfirmationAlert(
      "Would you like to send Quotation Requests for this Work Order?",
    );
    if (alert.isConfirmed) {
      showWorkOrderQuoteModal.value = true;
    } else {
      redirectToWorkOrderPage();
    }
  } else {
    redirectToWorkOrderPage();
  }
  if (props.workOrderId > 0) {
    await unLockWorkOrderItem();
    emit("workOrderUpdated");
  }
};

const callSaveApi = async () => {
  try {
    if (props.workOrderId == 0) {
      const newItem = await acquaintApiClient.httpPost<WorkOrders>(
        `database/WorkOrders`,
        workOrderData.value,
      );
      if (newItem) {
        newWorkOrderId.value = newItem.id;
        workOrderData.value = { ...newItem };
      }
    } else {
      await acquaintApiClient.httpPut<WorkOrders>(
        `database/WorkOrders/${props.workOrderId}`,
        workOrderData.value,
      );
    }
    return true;
  } catch (err) {
    if (props.workOrderId == 0) {
      displayErrorMessage("The new item could not be created.");
    } else {
      displayErrorMessage("The selected item could not be edited.");
    }
    return false;
  }
};

const redirectToWorkOrderPage = async () => {
  if (!props.fromMaintenanceRequest) {
    router.push({
      name: RouteNames.WorkOrdersPage,
      params: { workorderid: workOrderData.value.id.toString() },
    });
    closeModal();
    return true;
  }

  if (!workOrderData.value.contractorID) {
    closeModal();
    emit("workOrderCreated", newWorkOrderId.value);
    return;
  }

  const emailContractorPrompt = await displayQuestionAlert(
    "Do you want to email the Work Order to the Contractor now?",
  );
  if (!emailContractorPrompt.isConfirmed) {
    closeModal();
    emit("workOrderCreated", newWorkOrderId.value);
    return;
  }

  displayEmailModal.value = true;
};

const closeModal = () => {
  displayCloseConfirmationPrompt.value = false;
  lockedByAnotherUser.value = false;
  showModal.value = false;
};

watch(
  () => displayEmailModal.value,
  (val, preVal) => {
    if (!val && preVal) {
      closeModal();
      emit("workOrderCreated", newWorkOrderId.value);
    }
  },
);

const onQuotationEmailSent = () => {
  redirectToWorkOrderPage();
};

const onQuotationEmailModalClose = () => {
  redirectToWorkOrderPage();
};

const newContactCreated = (contactId: number) => {
  workOrderData.value.contactID = contactId;
};
const forceWidth = ref(false);
const handleKeyDown = (e: any) => {
  if (e.key === "Tab") {
    forceWidth.value = true;
  }
};

const onContractorChanged = () => {
  if (workOrderData.value.contractorID === -1) {
    workOrderData.value.contractorID = props.contractorId;
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(ModalBase, {
      modelValue: showModal.value,
      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((showModal).value = $event)),
      title: "Work Order",
      showCloseConfirmationPrompt: displayCloseConfirmationPrompt.value,
      height: "635",
      onCancelPromptDenied: cancelPromptDenied,
      onCancelConfirmationModal: keepEnteredInformation,
      onModalClosed: modalClosed
    }, {
      content: _withCtx(() => [
        _createVNode(_unref(DxTabPanel), {
          "scroll-by-content": true,
          "show-nav-buttons": true,
          "swipe-enabled": false,
          selectedIndex: selectedTab.value,
          "onUpdate:selectedIndex": _cache[15] || (_cache[15] = ($event: any) => ((selectedTab).value = $event))
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(DxItem), { title: "Main Details" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                  _createVNode(LookupSingleSelect, {
                    label: "Contractor",
                    modelValue: workOrderData.value.contractorID,
                    "onUpdate:modelValue": [
                      _cache[0] || (_cache[0] = ($event: any) => ((workOrderData.value.contractorID) = $event)),
                      onContractorChanged
                    ],
                    lookupSource: _unref(LookupTableSource).Contractors,
                    showSearch: true
                  }, null, 8, ["modelValue", "lookupSource"]),
                  _createVNode(PropertyLookup, {
                    modelValue: workOrderData.value.propertyID,
                    "onUpdate:modelValue": [
                      _cache[1] || (_cache[1] = ($event: any) => ((workOrderData.value.propertyID) = $event)),
                      onPropertyLookupChanged
                    ],
                    label: "Property",
                    required: _unref(WorkOrdersValidation).PropertyID.isRequired,
                    "display-navigate-icon": true,
                    readOnly: lockedByAnotherUser.value
                  }, null, 8, ["modelValue", "required", "readOnly"]),
                  _createElementVNode("div", {
                    class: "two-column-row-6-4",
                    onKeydown: handleKeyDown
                  }, [
                    _createVNode(AcquaintInfoBox, {
                      text: managementTypeDescription.value,
                      label: "Management Type"
                    }, null, 8, ["text"]),
                    _createVNode(CurrencyInfoBox, {
                      class: _normalizeClass({ 'forced-width': forceWidth.value }),
                      label: "Account Balance",
                      value: accountBalance.value
                    }, null, 8, ["class", "value"])
                  ], 32),
                  _createElementVNode("div", {
                    class: _normalizeClass({ 'two-column-row-6-4': tenantItem.value })
                  }, [
                    _createVNode(ContactLookup, {
                      modelValue: workOrderData.value.contactID,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((workOrderData.value.contactID) = $event)),
                      label: "Contact/Tenant",
                      isRequired: _unref(WorkOrdersValidation).ContactID.isRequired,
                      readOnly: lockedByAnotherUser.value,
                      showNewContactButton: true,
                      onOpenNewContactModal: _cache[3] || (_cache[3] = ($event: any) => (openNewContactModal.value = true))
                    }, null, 8, ["modelValue", "isRequired", "readOnly"]),
                    (tenantItem.value)
                      ? (_openBlock(), _createBlock(FieldValidationFreeDateBox, {
                          key: 0,
                          label: "Tenancy End Date",
                          modelValue: tenantItem.value.endDate,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((tenantItem.value.endDate) = $event)),
                          readOnly: true
                        }, null, 8, ["modelValue"]))
                      : _createCommentVNode("", true)
                  ], 2),
                  _createVNode(AcquaintTextbox, {
                    fieldValidation: _unref(WorkOrdersValidation).Subject,
                    label: "Subject",
                    modelValue: workOrderData.value.subject,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((workOrderData.value.subject) = $event)),
                    readOnly: lockedByAnotherUser.value,
                    validationGroup: "WorkOrderValidationGroup"
                  }, null, 8, ["fieldValidation", "modelValue", "readOnly"]),
                  _createVNode(AcquaintTextArea, {
                    fieldValidation: _unref(WorkOrdersValidation).Body,
                    label: "Body",
                    modelValue: workOrderData.value.body,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((workOrderData.value.body) = $event)),
                    readOnly: lockedByAnotherUser.value,
                    validationGroup: "WorkOrderValidationGroup"
                  }, null, 8, ["fieldValidation", "modelValue", "readOnly"])
                ])
              ]),
              _: 1
            }),
            _createVNode(_unref(DxItem), { title: "Details 2" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    _createVNode(CurrencyInput, {
                      modelValue: workOrderData.value.amount,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((workOrderData.value.amount) = $event)),
                      label: "Estimate",
                      minValue: 0,
                      maxValue: 99999999,
                      readOnly: lockedByAnotherUser.value,
                      fieldValidation: _unref(WorkOrdersValidation).Amount,
                      validationGroup: "WorkOrderValidationGroup"
                    }, null, 8, ["modelValue", "readOnly", "fieldValidation"]),
                    _createVNode(LookupSingleSelect, {
                      fieldValidation: _unref(WorkOrdersValidation).WorkOrderTypeID,
                      label: "Type",
                      modelValue: workOrderData.value.workOrderTypeID,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((workOrderData.value.workOrderTypeID) = $event)),
                      readOnly: lockedByAnotherUser.value,
                      "lookup-source": _unref(LookupTableSource).WorkOrderTypes
                    }, null, 8, ["fieldValidation", "modelValue", "readOnly", "lookup-source"])
                  ]),
                  _createElementVNode("div", _hoisted_4, [
                    _createVNode(AcquaintTextbox, {
                      fieldValidation: _unref(WorkOrdersValidation).Reference,
                      label: "Reference",
                      modelValue: workOrderData.value.reference,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((workOrderData.value.reference) = $event)),
                      readOnly: lockedByAnotherUser.value,
                      validationGroup: "WorkOrderValidationGroup"
                    }, null, 8, ["fieldValidation", "modelValue", "readOnly"]),
                    _createVNode(SystemCodeSingleSelect, {
                      "code-type": _unref(CodeType).WorkOrderStatus,
                      fieldValidation: _unref(WorkOrdersValidation).Status,
                      label: "Status",
                      modelValue: workOrderData.value.status,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((workOrderData.value.status) = $event)),
                      readOnly: lockedByAnotherUser.value
                    }, null, 8, ["code-type", "fieldValidation", "modelValue", "readOnly"])
                  ]),
                  _createElementVNode("div", _hoisted_5, [
                    _createVNode(ContactLookup, {
                      modelValue: workOrderData.value.assignedUserID,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((workOrderData.value.assignedUserID) = $event)),
                      fieldValidation: _unref(WorkOrdersValidation).AssignedUserID,
                      label: "Assigned User",
                      typeToFind: _unref(DefaultContactType).User,
                      readOnly: lockedByAnotherUser.value,
                      fixedWidth: 280
                    }, null, 8, ["modelValue", "fieldValidation", "typeToFind", "readOnly"]),
                    _createVNode(SystemCodeSingleSelect, {
                      "code-type": _unref(CodeType).WorkOrderPriority,
                      fieldValidation: _unref(WorkOrdersValidation).Priority,
                      label: "Priority",
                      modelValue: workOrderData.value.priority,
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((workOrderData.value.priority) = $event)),
                      readOnly: lockedByAnotherUser.value
                    }, null, 8, ["code-type", "fieldValidation", "modelValue", "readOnly"])
                  ]),
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(AcquaintDateBox, {
                      label: "Due Date",
                      modelValue: workOrderData.value.dueDate,
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((workOrderData.value.dueDate) = $event)),
                      readOnly: false,
                      fieldValidation: _unref(WorkOrdersValidation).DueDate,
                      requiredInput: false,
                      validationGroup: "WorkOrderValidationGroup",
                      disabled: lockedByAnotherUser.value
                    }, null, 8, ["modelValue", "fieldValidation", "disabled"]),
                    _createVNode(AcquaintDateBox, {
                      label: "Completed Date",
                      modelValue: workOrderData.value.completedDate,
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((workOrderData.value.completedDate) = $event)),
                      readOnly: false,
                      fieldValidation: _unref(WorkOrdersValidation).CompletedDate,
                      requiredInput: false,
                      validationGroup: "WorkOrderValidationGroup",
                      disabled: lockedByAnotherUser.value,
                      maxDate: currrentDate.value
                    }, null, 8, ["modelValue", "fieldValidation", "disabled", "maxDate"])
                  ])
                ])
              ]),
              _: 1
            }),
            false
              ? (_openBlock(), _createBlock(_unref(DxItem), {
                  key: 0,
                  title: "Pictures"
                }, {
                  default: _withCtx(() => [
                    _hoisted_7
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            false
              ? (_openBlock(), _createBlock(_unref(DxItem), {
                  key: 1,
                  title: "System Info"
                }, {
                  default: _withCtx(() => [
                    _hoisted_8
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["selectedIndex"])
      ]),
      footer: _withCtx(() => [
        _createVNode(_unref(DxToolbarItem), {
          widget: "dxButton",
          toolbar: "bottom",
          location: "after",
          options: {
          text: 'Save',
          disabled: workOrderData.value.propertyID == 0 || lockedByAnotherUser.value,
          onClick: (e) => {
            saveDetails(e);
          },
          validationGroup: 'WorkOrderValidationGroup',
        }
        }, null, 8, ["options"]),
        _createVNode(_unref(DxToolbarItem), {
          widget: "dxButton",
          toolbar: "bottom",
          location: "after",
          options: {
          text: 'Cancel',
          onClick: () => {
            cancelClick();
          },
        }
        }, null, 8, ["options"])
      ]),
      _: 1
    }, 8, ["modelValue", "showCloseConfirmationPrompt"]),
    _createVNode(WorkOrderQuotationModal, {
      modelValue: showWorkOrderQuoteModal.value,
      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((showWorkOrderQuoteModal).value = $event)),
      workOrderId: newWorkOrderId.value,
      onQuotationEmailSent: onQuotationEmailSent,
      onModalClosed: onQuotationEmailModalClose
    }, null, 8, ["modelValue", "workOrderId"]),
    _createVNode(EmailWorkOrderModal, {
      modelValue: displayEmailModal.value,
      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((displayEmailModal).value = $event)),
      "work-order-id": workOrderData.value.id
    }, null, 8, ["modelValue", "work-order-id"]),
    _createVNode(ContactModal, {
      modelValue: openNewContactModal.value,
      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((openNewContactModal).value = $event)),
      "default-type": _unref(ContactType).Tenant,
      onContactCreated: newContactCreated
    }, null, 8, ["modelValue", "default-type"])
  ], 64))
}
}

})